import { NavLink } from "react-router-dom";
import { Package, Users as UsersIcon, Factory } from "lucide-react";

export default function PublicNav() {
    return (
        <nav className="flex items-center gap-1 bg-[#3D4E2E] rounded-md p-1">
            <NavLink
                to="/"
                end
                data-testid="public-nav-stock"
                className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-1.5 rounded text-sm font-medium transition-colors ${
                        isActive
                            ? "bg-[#F5EFDA] text-[#2E3A22]"
                            : "text-[#D9D3B8] hover:bg-[#2E3A22] hover:text-white"
                    }`
                }
            >
                <Package className="w-4 h-4" />
                Stock
            </NavLink>
            <NavLink
                to="/production"
                data-testid="public-nav-production"
                className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-1.5 rounded text-sm font-medium transition-colors ${
                        isActive
                            ? "bg-[#F5EFDA] text-[#2E3A22]"
                            : "text-[#D9D3B8] hover:bg-[#2E3A22] hover:text-white"
                    }`
                }
            >
                <Factory className="w-4 h-4" />
                Production
            </NavLink>
            <NavLink
                to="/personnes"
                data-testid="public-nav-persons"
                className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-1.5 rounded text-sm font-medium transition-colors ${
                        isActive
                            ? "bg-[#F5EFDA] text-[#2E3A22]"
                            : "text-[#D9D3B8] hover:bg-[#2E3A22] hover:text-white"
                    }`
                }
            >
                <UsersIcon className="w-4 h-4" />
                Personnes
            </NavLink>
        </nav>
    );
}
